import { render, staticRenderFns } from "./Page3.vue?vue&type=template&id=1daefab0&scoped=true"
import script from "./Page3.vue?vue&type=script&lang=js"
export * from "./Page3.vue?vue&type=script&lang=js"
import style0 from "./Page3.vue?vue&type=style&index=0&id=1daefab0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1daefab0",
  null
  
)

export default component.exports